import { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Select, SelectProps } from 'antd';

import { OwnershipList } from '@/shared/lib/sj-orm/models/asset.dto';

export const SelectAssetOwnershipType: FC<SelectProps> = ({ placeholder, ...props }) => {
  const { t } = useTranslation('assets');

  const ownershipOptions = useMemo(() => {
    return OwnershipList.map(({ key, label }) => {
      return { value: key, label: t(label) };
    });
  }, [t]);

  return (
    <Select
      placeholder={placeholder ?? 'Select Ownership type'}
      options={ownershipOptions}
      {...props}
    />
  );
};
